module.exports = __webpack_public_path__ + "img/banner.d39e595c.svg";